import { useId } from 'react'

const formClasses =
  'block w-full appearance-none rounded-md border border-mid/60 bg-white px-3 py-2 text-dark placeholder-mid/70 focus:border-primary focus:bg-white focus:outline-hidden focus:ring-primary sm:text-sm'

function Label({ id, children }) {
  return (
    <label htmlFor={id} className="mb-3 block text-sm font-medium text-mid">
      {children}
    </label>
  )
}

export function TextField({ label, type = 'text', className, ...props }) {
  const id = useId()

  return (
    <div className={className}>
      {label && <Label id={id}>{label}</Label>}
      <input id={id} type={type} {...props} className={formClasses} />
    </div>
  )
}
